export function countryDisplay(s: string) {
  if (s === 'D') { return 'Deutschland' }
  
  return s
}